const iconMap: Record<string, any> = {
	'wave-arrow-right': (): any => import('@assets/svg/wave-arrow-right.svg'),
	'arrow-down': (): any => import('@assets/svg/arrow-down.svg'),
	'arrow-up': (): any => import('@assets/svg/arrow-up.svg'),
	'arrow-left': (): any => import('@assets/svg/arrow-left.svg'),
	'arrow-right': (): any => import('@assets/svg/arrow-right.svg'),
	close: (): any => import('@assets/svg/x.svg'),
	share: (): any => import('@assets/svg/share.svg'),
	suitcase: (): any => import('@assets/svg/suitcase.svg'),
	linkedin: (): any => import('@assets/svg/logo-linked-in.svg'),
	facebook: (): any => import('@assets/svg/logo-facebook.svg'),
	instagram: (): any => import('@assets/svg/logo-instagram.svg'),
	pinterest: (): any => import('@assets/svg/logo-pinterest.svg'),
	youtube: (): any => import('@assets/svg/logo-youtube.svg'),
	xing: (): any => import('@assets/svg/logo-xing.svg'),
	vk: (): any => import('@assets/svg/logo-vk.svg'),
	honeypot: (): any => import('@assets/svg/honeypot.svg'),
	upload: (): any => import('@assets/svg/upload.svg'),
	download: (): any => import('@assets/svg/download.svg'),
	notepad: (): any => import('@assets/svg/notepad.svg'),
	packaging: (): any => import('@assets/svg/packaging.svg'),
	'packaging-maoam': (): any => import('@assets/svg/packaging-maoam.svg'),
	spoon2: (): any => import('@assets/svg/spoon2.svg'),
	'whats-app': (): any => import('@assets/svg/whats-app.svg'),
	twitter: (): any => import('@assets/svg/twitter.svg'),
	email: (): any => import('@assets/svg/email.svg'),
	'product-cube': (): any => import('@assets/svg/product-piece-cube.svg'),
	'product-roll': (): any => import('@assets/svg/product-piece-roll.svg'),
	'loudspeaker-off': (): any => import('@assets/svg/loudspeaker-off.svg'),
	'loudspeaker-on': (): any => import('@assets/svg/loudspeaker-on.svg'),
	'map-pin': (): any => import('@assets/svg/map-pin.svg'),
	'map-phone': (): any => import('@assets/svg/map-phone.svg'),
	'map-directions': (): any => import('@assets/svg/map-directions.svg'),
	'magnifier-plus': (): any => import('@assets/svg/magnifier-plus.svg'),
	minus: (): any => import('@assets/svg/minus.svg'),
	plus: (): any => import('@assets/svg/plus.svg'),
	x: (): any => import('@assets/svg/x.svg')
};

export default iconMap;
